import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {react} from "mobx";
import {
    Button, FormGroup, Form,
    Input,
    Label,
    Table,
    Row, Col
} from 'reactstrap'
import 'moment/locale/pt-br';
import moment from "moment";

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import {LancamentoHoras} from "../components/LancamentoHoras";
import HorasExtrasStore from "../stores/HorasExtrasStore";
import DataWrapper from "../../../principal/containers/DataWrapper";
import _ from 'lodash';
import {DetalhamentoRecursoMOT} from "../components/DetalhamentoRecursoMOT";
import {FormWithActions} from "../../../comum/components/FormWithActions";
import {DetalhamentoHistorico} from "../../comum/components/DetalhamentoHistorico";
import {Redirect} from "react-router-dom";
import NumberFormat from "react-number-format";
import {formatarValorReal} from "../../../../utils/formatar";
import {LoadingPanel} from "../../../comum/components/LoadingPanel";
import {DetalhamentoTotal} from "../components/DetalhamentoTotal";
import {ResumoLancamento} from "../components/ResumoLancamento";

@inject("store")
@DataWrapper
@observer
export class EnvioHorasExtras extends Component {

    constructor(props) {
        super(props);

        this.appState = this.props.store.appState;
        this.aprovacao = this.props.aprovacao;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.formStore = this.props.store.formStore;
        this.modalStore = this.props.store.modalStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.loginStore = this.props.store.loginStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;


        this.controller = new HorasExtrasStore(this.tituloPaginaStore, this.loginStore, this.loadingPanelStore);
    }

    componentDidMount() {
        this.controller.verificarPeriodoEnvioTimesheetPermitido();
        this.controller.carregarDados(_.get(this.props, "match.params.taskIdBpm"));
        this.tituloPaginaStore.setTitulo("Horas trabalhadas");
    }

    save() {
        this.controller.rows[this.indexToSave] = this.controller.rowSelected;
        this.controller.modalIsOpen = !this.controller.modalIsOpen;
    }

    render() {
        if (this.formStore.acaoEnviada) {
            return <Redirect to="/horas-trabalhadas-pendentes" />;
        } else {
            return this.renderForm();
        }
    }

    renderForm() {
        const lancamentos = [];
        const lancamentosMobile = [];
        const self = this;
        const aprovacao = this.aprovacao;

        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <FormWithActions controller={this.controller}
                                                 taskId={_.get(this.props, "match.params.taskIdBpm")}
                                                 tarefa={this.controller.nomeTarefa}
                                                 possiveisAcoes={this.controller.possiveisAcoes}
                                                 error={this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm}>
                                    <DetalhamentoRecursoMOT/>
                                    <h4>Entrada timesheet</h4>
                                    {this.controller.timesheet.dataInicio != null &&
                                    <Row>
                                        <Col xs={12} md={4} lg={4}>
                                            <FormGroup>
                                                <Label>Competência</Label>
                                                <Input type="text" value={this.controller.competencia} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={4} lg={4}>
                                            <FormGroup>
                                                <Label>Período</Label>
                                                <Input type="textF" value={moment(this.controller.timesheet.dataInicio).format("DD/MM/YYYY" + " - " + moment(this.controller.timesheet.dataFim).format("DD/MM/YYYY"))} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={4} lg={4}>
                                            <FormGroup>
                                                <Label>Quantidade dias apurados</Label>
                                                <Input type="text" value={this.controller.quantidadeDias} readOnly/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    }
                                    <h4>Lançamentos</h4>
                                    <LancamentoHoras
                                        listaLancamentoDias={this.controller.listaLancamentoDias}
                                        tiposHora={this.controller.tiposHora}
                                        onChange={(value, tipo) => this.controller.setListaLancamentoDias(value, tipo)}
                                        dataInicio={this.controller.timesheet.dataInicio}
                                        dataFim={this.controller.timesheet.dataFim}
                                    />
                                    <Row>
                                        <Col xs={12}>
                                            <FormGroup>
                                                <Label>Observações gerais</Label>
                                                <Input type="textarea" value={_.get(this.controller, "timesheet.observacoes")} onChange={(event) => this.controller.setDetailsValue("observacoes", event.target.value)}/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <ResumoLancamento isEditavel/>
                                    <h4>Verbas</h4>
                                    <Row>
                                        {this.controller.exibeValorAche &&
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Ache {this.controller.labelPercentualAche} <span
                                                    style={{fontSize: 10}}>(sobre salário base)</span></Label>
                                                <NumberFormat
                                                    allowNegative={false}
                                                    value={_.get(this.controller, "timesheet.valorAche", 0) != null ? _.get(this.controller, "timesheet.valorAche", 0) : 0}
                                                    thousandSeparator={'.'}
                                                    className="form-control"
                                                    decimalSeparator={','}
                                                    prefix={'R$ '}
                                                    decimalPrecision={2}
                                                    onChange={(event, values) => this.controller.setDetailsValue("valorAche", values.floatValue)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        }
                                        {this.controller.exibeCampoGdvNoLancamentoHoras &&
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>GDV qtd dias</Label>
                                                <Input type="text" value={this.controller.quandidadeDiasGDV} readOnly/>
                                            </FormGroup>
                                        </Col>
                                        }
                                        {this.controller.exibeValorGdv &&
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>GDV {this.controller.labelPercentualGdv}  <span
                                                    style={{fontSize: 10}}>(sobre salário base)</span></Label>
                                                <NumberFormat allowNegative={false}
                                                              value={_.get(this.controller, "timesheet.valorGdv", 0) != null ? _.get(this.controller, "timesheet.valorGdv", 0): 0}
                                                              thousandSeparator={'.'}
                                                              className="form-control"
                                                              decimalSeparator={','}
                                                              prefix={'R$ '}
                                                              decimalPrecision={2}
                                                              onChange={(event, values) => this.controller.setDetailsValue("valorGdv",values.floatValue)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        }
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Insalubridade <span style={{fontSize: 10}}>(sobre salário mínimo)</span></Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorInsalubridade", 0) != null ? _.get(this.controller, "timesheet.valorInsalubridade", 0): 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorInsalubridade",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Periculosidade <span
                                                    style={{fontSize: 10}}>(sobre salário base)</span></Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorPericulosidade", 0) != null ? _.get(this.controller, "timesheet.valorPericulosidade", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorPericulosidade",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Gratificação</Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorGratificacao", 0) != null ? _.get(this.controller, "timesheet.valorGratificacao", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorGratificacao",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>DSR horas extras</Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorDsrHorasExtras", 0) != null ? _.get(this.controller, "timesheet.valorDsrHorasExtras", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorDsrHorasExtras",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>DSR adicional noturno</Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorDsrAdicionalNoturno", 0) != null ? _.get(this.controller, "timesheet.valorDsrAdicionalNoturno", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorDsrAdicionalNoturno",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Outros proventos</Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorOutrosProventos", 0) != null ? _.get(this.controller, "timesheet.valorOutrosProventos", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorOutrosProventos",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Outros descontos</Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorOutrosDescontos", 0) != null ? _.get(this.controller, "timesheet.valorOutrosDescontos", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorOutrosDescontos",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>VT</Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorVt", 0) != null ? _.get(this.controller, "timesheet.valorVt", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorVt",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>VR</Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorVr", 0) != null ? _.get(this.controller, "timesheet.valorVr", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorVr",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>ASO</Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorAso", 0) != null ? _.get(this.controller, "timesheet.valorAso", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorAso",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} md={3} lg={3}>
                                            <FormGroup>
                                                <Label>Reembolso de viagens</Label>
                                                <NumberFormat allowNegative={false} value={_.get(this.controller, "timesheet.valorReembolsoViagens", 0) != null ? _.get(this.controller, "timesheet.valorReembolsoViagens", 0) : 0}  thousandSeparator={'.'}
                                                              className="form-control" decimalSeparator={','} prefix={'R$ '} decimalPrecision={2} onChange={(event, values) => this.controller.setDetailsValue("valorReembolsoViagens",values.floatValue)}/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <FormGroup>
                                                <Label>Observações sobre as verbas</Label>
                                                <Input type="textarea" value={_.get(this.controller, "timesheet.observacoesVerbasAdicionais") != null ? _.get(this.controller, "timesheet.observacoesVerbasAdicionais") : ""}   onChange={(event) => this.controller.setObservacao(event.target.value)} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <DetalhamentoTotal />
                                    <DetalhamentoHistorico />
                                </FormWithActions>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        );
    }
}
